import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Clock, Info } from 'lucide-react';

export default function Program() {
  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <h1 className="text-3xl font-bold text-slate-800 border-b pb-4">Program cu Publicul</h1>

      <div className="bg-blue-50 border-l-4 border-blue-600 p-4 rounded-r-lg text-sm text-blue-900 shadow-sm flex items-start gap-3">
        <Info className="w-5 h-5 flex-shrink-0 mt-0.5" />
        <p>
          <strong>Notă informativă:</strong> Programul de mai jos reflectă fluxurile operaționale la ghișee. 
          Persoanele programate online sunt rugate să respecte cu strictețe ora alocată sistemului.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-6 mt-6">
        {/* INMATRICULARI */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-blue-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Înmatriculări Definitive / Radieri
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-2 text-sm text-slate-700">
            <div className="flex justify-between border-b pb-2"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">08:30 - 12:00 | 12:30 - 15:30</span></div>
            <div className="flex justify-between"><span>Vineri</span> <span className="font-semibold text-red-600">08:30 - 12:00 | 12:30 - 13:30</span></div>
          </CardContent>
        </Card>

        {/* INMATRICULARI PROVIZORII */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-blue-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Înmatriculări Provizorii
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-2 text-sm text-slate-700">
            <div className="flex justify-between border-b pb-2"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">08:30 - 12:00 | 12:30 - 14:00</span></div>
            <div className="flex justify-between"><span>Vineri</span> <span className="font-semibold text-red-600">08:30 - 12:00 | 12:30 - 13:30</span></div>
          </CardContent>
        </Card>

        {/* PERMISE - PRIMIRI */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-emerald-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Permise Conducere (Primiri Documente)
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-2 text-sm text-slate-700">
            <div className="flex justify-between border-b pb-2"><span>Luni, Marți, Joi</span> <span className="font-semibold">08:30 - 12:00 | 12:30 - 15:30</span></div>
            <div className="flex justify-between border-b pb-2 bg-emerald-50 px-2 rounded"><span>Miercuri (Program Prelungit)</span> <span className="font-bold text-emerald-700">08:30 - 12:00 | 12:30 - 18:00</span></div>
            <div className="flex justify-between"><span>Vineri</span> <span className="font-semibold text-red-600">08:30 - 12:00 | 12:30 - 13:30</span></div>
          </CardContent>
        </Card>

        {/* PERMISE - ELIBERARI */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-emerald-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Permise Conducere (Eliberări)
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-2 text-sm text-slate-700">
            <div className="flex justify-between border-b pb-2"><span>Luni, Marți, Joi</span> <span className="font-semibold">14:30 - 16:00</span></div>
            <div className="flex justify-between border-b pb-2 bg-emerald-50 px-2 rounded"><span>Miercuri (Program Prelungit)</span> <span className="font-bold text-emerald-700">14:30 - 18:00</span></div>
            <div className="flex justify-between"><span>Vineri</span> <span className="font-semibold text-red-600">14:00 - 16:00</span></div>
          </CardContent>
        </Card>

        {/* EXAMINARI STANDARD */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-amber-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Examinări (Primiri și Programare Practică)
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-3 text-sm text-slate-700">
            <div>
              <p className="font-semibold text-slate-900 border-b pb-1 mb-1">Primiri documente dosar examinare:</p>
              <div className="flex justify-between"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">08:30 - 12:00 | 12:30 - 14:00</span></div>
            </div>
            <div>
              <p className="font-semibold text-slate-900 border-b pb-1 mb-1">Programare/Reprogramare Proba Practică:</p>
              <div className="flex justify-between"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">14:00 - 16:00</span></div>
            </div>
            <div className="bg-red-50 text-red-800 text-center py-1 font-bold rounded">Vineri: ÎNCHIS</div>
          </CardContent>
        </Card>

        {/* EXAMINARI TEORETICE ONLINE & SECRETARIAT */}
        <Card className="shadow-md border-slate-200">
          <CardHeader className="bg-slate-50/50 border-b border-slate-100 pb-4">
            <CardTitle className="text-lg text-slate-800 flex items-center gap-2">
              <Clock className="w-5 h-5"/> Sală On-Line & Secretariat
            </CardTitle>
          </CardHeader>
          <CardContent className="pt-4 space-y-3 text-sm text-slate-700">
            <div>
              <p className="font-semibold text-slate-900 border-b pb-1 mb-1">Primiri doc. proba teoretică (Sala On-Line):</p>
              <div className="flex justify-between"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">08:30 - 12:00 | 12:30 - 14:00</span></div>
              <div className="text-red-600 font-medium mt-1">Vineri: ÎNCHIS</div>
            </div>
            <div className="pt-2">
              <p className="font-semibold text-slate-900 border-b pb-1 mb-1">Secretariat (Primiri și Eliberări):</p>
              <div className="flex justify-between"><span>Luni, Marți, Miercuri, Joi</span> <span className="font-semibold">08:30 - 10:30 | 14:00 - 16:00</span></div>
              <div className="flex justify-between"><span>Vineri</span> <span className="font-semibold text-red-600">08:30 - 10:30</span></div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <div className="flex items-center gap-3 border-b pb-4">
        <Clock className="w-8 h-8 text-blue-600" />
        <h1 className="text-3xl font-bold text-slate-800">Program de lucru cu publicul</h1>
      </div>

      <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex gap-3 text-amber-800 text-sm my-6">
        <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" />
        <p>Vă rugăm să respectați programul afișat pentru fiecare tip de operațiune în parte. Accesul la ghișee se face pe baza programărilor online acolo unde este specificat.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-6">
        {scheduleData.map((item, index) => (
          <Card key={index} className="shadow-sm border-slate-200 overflow-hidden">
            <div className="h-2 bg-blue-600 w-full"></div>
            <CardHeader className="bg-slate-50 pb-4">
              <CardTitle className="text-lg text-blue-900">{item.title}</CardTitle>
              {item.subtitle && <p className="text-xs text-slate-500 mt-1 font-medium">{item.subtitle}</p>}
            </CardHeader>
            <CardContent className="pt-4">
              <ul className="space-y-3">
                {item.schedule.map((sch, i) => (
                  <li key={i} className="flex justify-between items-center border-b border-slate-100 last:border-0 pb-2 last:pb-0">
                    <span className="font-semibold text-slate-700 text-sm flex items-center gap-2">
                      <Calendar className="w-4 h-4 text-slate-400" />
                      {sch.days}
                    </span>
                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-bold">
                      {sch.hours}
                    </span>
                  </li>
                ))}
              </ul>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
